import {useTheme} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";
import {useRef, useState} from "react";
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent, Divider,
    FormControl,
    Grid,
    InputAdornment,
    Skeleton,
    TextField,
    Typography
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {FlexBox} from "../Theme/CustomComponent";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {WordPressToolsConsigneeDetails} from "./WordPressToolsConsigneeDetails";
import CloudflareTurnstile from "../Cpatcha/CloudflareTurnstile";

export const WordPressToolsOneTimeCode = () => {

    const theme = useTheme();

    const {lng} = useParams();

    const uiText = getI18nContent(lng, 'LTLTools');

    const [bolNumber, setBolNumber] = useState('');
    const [oneTimeCode, setOneTimeCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [consigneeData, setConsigneeData] = useState(null);

    const getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber = async () => {

        if (!bolNumber.trim() || !oneTimeCode.trim()) return;

        try {
            setLoading(true);
            setError(false);
            setErrorMessage('');
            setConsigneeData(null);

            const params = {
                bolNumber: bolNumber,
                confirmationCode: oneTimeCode
            };

            const requestURL = `${PARTNER_URI}/shippingLTL/getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber`;
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: params
            });

            setConsigneeData(result.data);

            setError(false);
        } catch (e) {
            setError(true);
            setErrorMessage(e.response?.data?.error || "Unknown Error");

        } finally {
            setLoading(false);
        }
    }

    const handleBolNumber = (event) => {
        const {value} = event.target;
        setBolNumber(value);
    }

    const handleOneTimeCode = (event) => {
        const {value} = event.target;
        setOneTimeCode(value);
    }

    return (
        <Grid container spacing={1}>
            <Grid size={{md: 5, xs: 12}}>
                <FormControl fullWidth>
                    <TextField
                        value={bolNumber}
                        fullWidth
                        variant='outlined'
                        required
                        label={`${uiText.search.label}: ${uiText.search.types.bol}`}
                        placeholder={uiText.search.placeholder}
                        onInput={handleBolNumber}
                        size='small'
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{md: 5, xs: 12}}>
                <FormControl fullWidth>
                    <TextField
                        value={oneTimeCode}
                        fullWidth
                        variant='outlined'
                        required
                        label={`${uiText.search.label}: ${uiText.search.types.confirmationCode}`}
                        placeholder={uiText.search.placeholder}
                        onInput={handleOneTimeCode}
                        size='small'
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{md: 2, xs: 12}}>
                <FlexBox justifyContent='flex-end'>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber}
                    >
                        {uiText.search.button.consignee}
                    </Button>
                </FlexBox>
            </Grid>
            {loading && (
                <Grid size={{xs: 12}}>
                    <Card sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        <CardContent>
                            <Skeleton variant="text" width="40%" height={30}/>
                            <Divider sx={{my: 2}}/>
                            <Skeleton variant="rectangular" height={60} sx={{mb: 1, borderRadius: 1}}/>
                            <Skeleton variant="rectangular" height={60} sx={{borderRadius: 1}}/>
                        </CardContent>
                    </Card>
                </Grid>
            )}
            {error && (
                <Grid size={{xs: 12}}>
                    <Alert severity="error" icon={<ErrorOutlineIcon/>} sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        {uiText.search.error} {errorMessage || ""}
                    </Alert>
                </Grid>
            )}
            {(!loading && !error && !!consigneeData) &&
                <Grid size={{xs: 12}}>
                    <WordPressToolsConsigneeDetails consigneeData={consigneeData}
                                                    bolNumber={bolNumber}
                                                    oneTimeCode={oneTimeCode}
                                                    getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber={getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber}/>
                </Grid>
            }
        </Grid>
    )
}